import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../api';

export const fetchPlans = createAsyncThunk('billing/fetchPlans', async () => {
  const res = await api.get('/billing/plans');
  return res.data;
});

export const fetchTransactions = createAsyncThunk('billing/fetchTransactions', async () => {
  const res = await api.get('/billing/transactions');
  return res.data;
});

export const createCheckout = createAsyncThunk('billing/checkout', async (plan) => {
  const res = await api.post('/billing/checkout', { plan });
  return res.data;
});

const billingSlice = createSlice({
  name: 'billing',
  initialState: {
    plans: [],
    transactions: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPlans.fulfilled, (state, action) => { state.plans = action.payload; })
      .addCase(fetchTransactions.pending, (state) => { state.loading = true; })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload;
      })
      .addCase(fetchTransactions.rejected, (state) => { state.loading = false; });
  },
});

export default billingSlice.reducer;
